import React from 'react';
import { Banner, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

const SemanticProcessingBanner = (props) => {
  const { i18n } = props;
  return (
    <Banner
      status='info'
    >
      {i18n.translate('AdminHTML.SemanticSearch.Banner.autoSync', {
        t1: <TextStyle variation='strong'>{i18n.translate('AdminHTML.SemanticSearch.Banner.autoSync_t1')}</TextStyle>
      })}
    </Banner>
  );
};

export default withI18n()(SemanticProcessingBanner);